module.exports = __webpack_public_path__ + "img/eye-img.15125ea4.svg";